
import React, {FC} from 'react';
import {NavProps} from 'components/Header';
import {Group} from 'components/Header/navs';

import Link from './Link/Link';

import * as styles from './styles.module.scss';

type GroupProps = NavProps & {
	group: Group
}

const _Group: FC<GroupProps> = ({nav, group}) => {

	return (
		<div className={styles.group}>
			<div className={styles.text}>
				{group.text}
			</div>
			<div className={styles.links}>
				{group.links.map((l, i) => (
					<Link nav={nav} link={l} key={i} />
				))}
			</div>
		</div>
	);
};

export default _Group;

